/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import ReactModal from 'react-modal'
import ButtonWithIcon from 'apps/ButtonWithIcon'
import Heading from 'elements/Heading'
import * as styles from './Modal.scss'

const cx = classNames.bind(styles)

interface IProps {
  closeModal: (param: any) => void,
  name: string,
  isOpen: boolean,
  shouldCloseOnOverlayClick?: boolean,
  styleType?: string,
  header?: string | React.ReactChildren,
  hideCloseButton?: boolean,
}

interface IState {
  overlayStyle: { height: number } | null,
}

export default class Modal extends React.Component<IProps, IState> {
  public readonly state = {
    overlayStyle: null,
  }
  public componentDidMount () {
    if (this.props.styleType === 'banner') {
      window.addEventListener('resize', this.onCalcOverlayStyle)
    }
  }

  public componentWillUnmount () {
    window.removeEventListener('resize', this.onCalcOverlayStyle)
  }

  private onCalcOverlayStyle = () => {
    if (this.props.styleType === 'banner') {
      const { height } = this.contentRef.getBoundingClientRect()
      this.setState({
        overlayStyle: {
          height,
        },
      })
    }
  }

  private onCloseModal = () => {
    const { closeModal, name } = this.props
    closeModal({ name })
  }

  private readonly contentRef = null

  public render () {
    const {
      isOpen,
      shouldCloseOnOverlayClick = true,
      styleType = 'default',
      header,
      hideCloseButton = false,
    } = this.props
    const { overlayStyle } = this.state

    return (
      <ReactModal
        isOpen={isOpen}
        ariaHideApp={false} // fixed warning
        onAfterOpen={this.onCalcOverlayStyle}
        onRequestClose={this.onCloseModal}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        className={{
          base: cx('modalContent', styleType),
          afterOpen: '',
          beforeClose: '',
        }}
        overlayClassName={{
          base: cx('modalOverlay', styleType),
          afterOpen: '',
          beforeClose: '',
        }}
        style={{ overlay: overlayStyle }}
      >
        <div ref={r => { this.contentRef = r }} className={cx('modalBody', styleType)}>
          {!!header && (
            <header className={styles.modalHeader}>
              <Heading size={4}>{header}</Heading>
              {!hideCloseButton && (
                <div className={styles.modalHeaderButton}>
                  <ButtonWithIcon
                    iconName='close'
                    onClick={this.onCloseModal}
                    size='xLarge'
                    styleType='noStyle'
                  />
                </div>
              )}
            </header>
          )}
          {this.props.children}
        </div>
      </ReactModal>
    )
  }
}
